/**
 * Задание stylepack/option-indicator — нарисованная отметка выбора (вид
 * «box»): квадрат или круг по полям блока, у отмеченного — заливка и белая
 * галочка. Украшение (`aria-hidden`): выбор по-прежнему делает и озвучивает
 * родной `<input>` той же строки, спрятанный накладкой
 * `optionIndicatorInputOverride` (optionIndicator.ts).
 *
 * Не тот вид или «без отметки» — ничего не рисует. Место в строке — из стиля
 * (`order`): вызывающий ставит отметку после содержимого строки.
 */
import React from 'react';
import {
  OPTION_INDICATOR_TICK_COLOR,
  optionIndicatorBoxStyle,
  optionIndicatorBoxed,
  optionIndicatorSizeOf,
  type OptionIndicatorFields,
  type OptionIndicatorKind,
} from './optionIndicator';

interface Props {
  fields: OptionIndicatorFields;
  kind: OptionIndicatorKind;
  checked: boolean;
}

export function OptionIndicatorBox({ fields, kind, checked }: Props) {
  if (!optionIndicatorBoxed(fields)) return null;
  const tick = Math.round(optionIndicatorSizeOf(fields) * 0.7);
  return (
    <span
      aria-hidden="true"
      data-testid="option-indicator-box"
      data-checked={checked ? 'true' : 'false'}
      style={optionIndicatorBoxStyle(fields, kind, checked)}
    >
      {checked && (
        <svg
          data-testid="option-indicator-tick"
          width={tick}
          height={tick}
          viewBox="0 0 24 24"
          aria-hidden="true"
        >
          <path
            d="M5 12.5l4.5 4.5L19 7.5"
            fill="none"
            stroke={OPTION_INDICATOR_TICK_COLOR}
            strokeWidth={3}
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      )}
    </span>
  );
}
